export enum SituacaoPrecatoriaExternaIcon {
  EM_PREENCHIMENTO = "edit",
  ENVIADA = "send",
  RECEBIDA = "mat_outline:mark_email_read",
  FINALIZADA = "heroicons_outline:check",
  CUMPRIDA = "heroicons_outline:chevron-double-left",
  PARCIALMENTE_CUMPRIDA = "heroicons_outline:chevron-left",
}

export enum SituacaoPrecatoriaExterna {
  EM_PREENCHIMENTO = "Preenchimento",
  ENVIADA = "Enviada",
  RECEBIDA = "Recebida",
  FINALIZADA = "Finalizada",
  CUMPRIDA = "Devolvida Cumprida",
  PARCIALMENTE_CUMPRIDA = "Devolvida parcialmente Cumprida",
  DEVOLVIDA_SEM_CUMPRIMENTO ="Devolvida sem cumprimento",
}

export enum SituacaoDevolverPrecatoria {
  CUMPRIDA = "Cumprida",
  DEVOLVIDA_SEM_CUMPRIMENTO ="Devolvida sem cumprimento",
  PARCIALMENTE_CUMPRIDA = "Parcialmente cumprida",
}

export enum TipoEnvolvido {
  VITIMA = "Vítima",
  AUTOR = "Autor do Fato/Investigado",
  TESTEMUNHA = "Testemunha",
}

export enum TipoContato {
  CELULAR = "Celular",
  RESIDENCIAL = "Residencial",
  COMERCIAL = "Comercial",
  OUTROS = "Outros",
  WHATSAPP = "Whatsapp",
  EMAIL_PESSOAL = "Email Pessoal",
  EMAIL_COMERCIAL = "Email Comercial",
  EMAIL_OUTROS = "Email Outros",
}

export enum TipoEndereco {
  RESIDENCIAL = "Residencial",
  COMERCIAL = "Comercial",
  RURAL = "Rural",
  OUTROS = "Outros",
}

export enum OrientacaoSexual {
  BISSEXUAL = "Bissexual",
  HETEROSSEXUAL = "Heterossexual",
  HOMOSSEXUAL = "Homossexual",
}

export enum EstadoCivil {
  VIUVO = "Viúvo",
  CASADO = "Casado",
  SOLTEIRO = "Solteiro",
  CONVIVENTE = "Convivente",
  DIVORCIADO = "Divorciado",
}

export enum Escolaridade {
  ANALFABETO = "NÃO ALFABETIZADO",
  ALFABETIZADO = "ALFABETIZADO",
  FUNDAMENTAL = "ENSINO FUNDAMENTAL(antigo 1º Grau)",
  MEDIO = "ENSINO MÉDIO (antigo 2º Grau)",
  SUPERIOR = "GRADUAÇÃO",
  POSGRADUADO = "PÓS-GRADUAÇÃO",
}

export enum MotivoPrecatoria {
  OITIVA = "Oitiva",
  INTERROGATORIO = "Interrogatório",
  ORDEM_SERVICO = "Ordem de Serviço",
  OUTRO = "Outro",
}

export enum PerfilUsuario {
  DEPRECANTE, 
  DEPRECADO,
}

export enum ETipoProcedimento {
  AI = "PROCEDIMENTO DE APURAÇÃO DE ATO INFRACIONAL",
  IP = "INQUÉRITO POLICIAL",
  BOLETIM_OCORRENCIA =  "BOLETIM DE OCORRÊNCIA",
  TCO = "TERMO CIRCUNSTANCIADO DE OCORRÊNCIA",
  OUTRO = "OUTRO",
}

//Operação de tela
export enum Operacao {
  edit = "Editar",
  view = "Visualizar",
  new = "Cadastrar",
  addFoto = "Adicionar Foto",
}

//Para obter o tipo das imagens que
//precisa ser carregado automaticamente
//na tela.
export enum TypeImg {
  JPEG,
  PNG,
  ZIP,
  SVG,
  JPG,
  GIF,
}

export enum ECutis {
  AMARELA = "AMARELA",
  BRANCA = "BRANCA",
  INDIGENA = "INDIGENA",
  PARDA = "PARDA",
  PRETA = "PRETA",
}

export enum EIdentidadeGenero {
  TRANSEXUAL = "TRANSEXUAL",
  TRAVESTI = "TRAVESTI",
}

export enum ETipoCampoPesquisaAvancada {
  TEXTO = 'TEXTO',
  NUMERICO = 'NUMERICO',
  DATA = 'DATA',
  DATA_RANGE = 'DATA_RANGE',
  ENUM = 'ENUM',
}
